import { useMemo, useReducer, useState } from "react";
import { InputGroup, FormControl, Modal, Button, Alert, Col, Form, Row, Container } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GetHeadersOpts } from '../../App';
import PagerTable from '../../common/tables/PagerTable'
import FinderFileEditor from "./FinderFileEditor";
import Confirm from '../../common/widgets/Confirm'
import FilterCriteria from "../../common/tables/FilterCriteria"
import ValResult from "../../common/widgets/ValResult"
import './ListEditor.css'


interface ListEditorProps {
    onListSaved: (close?: boolean) => void,
    getHeaders: (opts?: GetHeadersOpts) => Headers
    list: any
}

const ListEditor = (props: ListEditorProps) => {

    const { list } = props;

  const [frm, setFrm] = useState({
    fileName: list.fileName ? list.fileName : '',
    mailDropDate: list.mailDropDate ? list.mailDropDate : '',
    totalRecords: list.totalRecords ? list.totalRecords : '0',
    successRecords: list.successRecords ? list.successRecords : '0',
    errorRecords: list.errorRecords ? list.errorRecords : '0',
    customfield: list.customfield ? list.customfield : '0'
  });
  const [finderFileRecord, setFinderFileRecord] = useState<any>(null); // FinderFiles List
  const [delmode, setDelmode] = useState(list.id === "0" ? "disabled" : ""); // possible values: disabled, blank, prompt, confirmed
  const [tableData, setTableData] = useState<any>({
    count: 0,
    data: [],
  }) // current data (FinderFiles) for table. 
  const [refresh, doRefresh] = useReducer((d) => d + 1, 0);
  const [filter, setFilter] = useState<FilterCriteria>([]);
  const [errors, setErrors] = useState({ fileName: "", mailDropDate: "", successRecords: "", errorRecords: "", totalRecords: "", customfield: "" })
  const [alertx, setAlertx] = useState<any>({ message: "", variant: "", setShow: true })
  const [mailDropDate, setMailDropDate] = useState(new Date()); // this is for DatePicker

    // FIXME... OLX still stuck on FA V4... need to update to at least 5
    let faIconClass = sessionStorage.getItem("pencilimg") ?? ""

    /* use good old javascript to prevent excessive queries. each all to this function will
      will interrupt the prior call, until 1 second elapses... then the state will be updated */
    var finderFileBatchDTO: any;
    const onSearchChanged = (srchText: string) => {

        if (finderFileBatchDTO !== null) clearTimeout(finderFileBatchDTO);// clear previous timeout. 
        if (srchText.length < 2) {
            if (filter.length === 0) return;
            else {
                // clear filter first, then return. 
                setFilter([]);
                return;
            }
        }

        var f: FilterCriteria = [{ name: "all", filterText: srchText }];
        var cb = () => { setFilter(f); };
        finderFileBatchDTO = window.setTimeout(cb, 250); // call search shortly      
    }

    const close = () => {
        props.onListSaved();
    }


    const onDeleteConfirm = (resp: boolean) => {
        if (resp) {
            onListSaved(); // initiate save to delete
        }
        else {
            setDelmode("") // clear confirm popup.
        }
    }


    const onListSaved = () => {

        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/FinderFilesBatch`;
        //console.log("Preparing to call api:" + _url);

        // DTO for FinderFilesBatch
        var data = {
            ...frm,
            id: list.id,
            mailDropDate: mailDropDate,
            successRecords: frm.successRecords,
            errorRecords: frm.errorRecords,
            totalRecords: frm.totalRecords,
            customfield: frm.customfield
        }

        fetch(_url,
            {
                method: list.id === "0" ? "POST" : delmode === "prompt" ? "DELETE" : "PUT",
                headers: props.getHeaders(),
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then((resp: any) => {
                if (resp.success) {
                    if (list.id === "0") {
                        // add... leave open so FinderFiles can be added. 
                        props.onListSaved({
                            ...list,
                            id: resp.newid,
                            fileName: list.fileName,
                            mailDropDate: list.mailDropDate
                        });

                        setAlertx({ message: "List saved successfully. Click save again to close, or add FinderFiles.", variant: "success", setShow: true });

                    }
                    else props.onListSaved(); // update... close when saved

                }
                else {

                    if (resp.hasOwnProperty("errors")) {
                        var err = resp.errors;
                        var newErrors = { ...errors };
                        newErrors.fileName = err.FileName ? err.FileName[0] : ""
                        newErrors.mailDropDate = err.MailDropDate ? err.MailDropDate[0] : ""
                        newErrors.totalRecords = err.TotalRecords ? err.TotalRecords[0] : ""
                        newErrors.successRecords = err.SuccessRecords ? err.SuccessRecords[0] : ""
                        newErrors.errorRecords = err.ErrorRecords ? err.ErrorRecords[0] : ""
                        newErrors.customfield = err.customfield ? err.customfield[0] : ""
                        setErrors(newErrors);

                        //if (err.fileName === "" && err.mailDropDate === "" && err.errorRecords === "" && err.successRecords === "" && err.totalRecords === "" && err.customfield === "") {
                        //    setAlertx({ message: "An error occurred. Please try again later.", variant: "danger", setShow: true });
                        //}
                    }

                }
                // 
            });

    }

    const onFinderFileSaved = () => {

        // trigger a refresh of the address by updating the refresh # 
        doRefresh();

        // Be Careful.. the above table refresh won't happen if the Address popup (which initiated this event)
        // is hidden first. So make sure the following line occurs last. 
        setFinderFileRecord(null);
    }


    const newFinderFileRecord = () => {

        if (list.id === "0") {
            // show alert
            setAlertx({ message: "Please save finder file batch before adding a finder file record.", variant: "danger", setShow: true });
            return;
        }
        else if (alertx.message) setAlertx({ message: "", variant: "", setShow: false });

        // create a new list object for editor. 
        const a = {
            id: "0",
            batchID: list.id,
            firstName: "",
            lastName: "",
            fullName: "",
            addressOne: "",
            addressTwo: "",
            city: "",
            state: "",
            zipcode: "",
            keyCode: "",
            finderNumber: "",
            customerNumber: "",
            fileName: list.fileName,
            fileLineNumber: (list.totalRecords ? list.totalRecords + 1 : 1),
            campaignID: 0,
            fileRunDate: new Date().toLocaleString().replace(", 12:00:00 AM", "")
        }
        setFinderFileRecord(a);
    }

    const columns = useMemo(
        () => [
            {
                Header: <i className='fa fa-solid fa-plus' onClick={() => newFinderFileRecord()} />,
                accessor: 'editbtn', // accessor is the "key" in the data
                maxWidth: 30
            },
            //{
            //    Header: 'Batch ID',
            //    accessor: 'batchID',
            //    minWidth: 65,
            //    maxWidth: 65
            //},
            {
                Header: 'Full Name',
                accessor: "fullName",
                maxWidth: 100
            },
            {
                Header: 'Address',
                accessor: "fullAddress",
            },
            {
                Header: 'Key Code',
                accessor: "keyCode",
                minWidth: 70,
                maxWidth: 70
            },
            {
                Header: 'Finder #',
                accessor: "finderNumber",
                minWidth: 80,
                maxWidth: 80
            },
            {
                Header: 'Customer #',
                accessor: "customerNumber",
                minWidth: 100,
                maxWidth: 100
            },
            {
                Header: 'File Run Date',
                accessor: "fileRunDate",
                maxWidth: 100
            },
            {
                Header: 'Create Date',
                accessor: "createDate",
                maxWidth: 100
            }
        ],
        [list, alertx] // newFinderFileRecord in column A needs to bind with current id if List changes.
    )

    const getData = (pageSize: number, pageIndex: number) => {
        const apiBase = sessionStorage.getItem("apibase");

        var filt;
        if (filter.length > 0) {
            // filter is used.. will have to use complex encoding. In this case
            var srch = {
                batchId: list.id,
                search: filter[0].filterText
            }
            const es = btoa(JSON.stringify(srch)); // encode combined search criteria. 
            filt = `&searchField=complex&searchPhrase=${es}`;
        }
        else {
            if (list.id === "new")
                filt = `&searchField=batchId&searchPhrase=${0}`;
            else
                // pass single list id as sole criteria. 
                filt = `&searchField=batchId&searchPhrase=${list.id}`;
        }

        var _url = `${apiBase}/v1/FinderFiles?page=${pageIndex}&pageSize=${pageSize}${filt}`;
        //console.log("Preparing to call api:" + _url);

        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {

                // first column will container button
                resp.data.map((d: any) => {
                    d.editbtn = <i className={faIconClass} onClick={() => setFinderFileRecord(d)} />
                    d.fileRunDate = new Date(d.fileRunDate).toLocaleString().replace(", 12:00:00 AM", "")
                    d.createDate = new Date(d.createDate).toLocaleString()
                    d.fullAddress = d.addressOne + " " + d.addressTwo + " " + d.city + " " + d.state + " " + d.zipcode
                });
                setTableData(resp);
                //we need to reload batch information when FinderFile (FinderFileEditor.tsx) Modal is closed
                reloadBatch();
            });
    }

    const reloadBatch = () => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/FinderFilesBatch/${list.id}`;
        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {
                if (resp.data[0])
                    setFrm({ ...frm, totalRecords: resp.data[0].totalRecords, successRecords: resp.data[0].successRecords });
            });
    }

    const onFormChange = (name: string, e: any) => {
        const newValues = { ...frm, [name]: e.target.value };
        setFrm(newValues);
    }

    const onMailDropDateChange = (mailDropDate: Date) => {
        setMailDropDate(mailDropDate);

        setFrm({ ...frm, ["mailDropDate"]: mailDropDate });
    }



    return (
        <>

            <Modal show={true} onHide={close} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Finder File Batch</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>


                            {alertx.message ? <div><Alert variant={alertx.variant} show={alertx.setShow} onClose={() => setAlertx({ setShow: false })} dismissible >{alertx.message}</Alert></div> : null}

                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={2}>
                                    File Name
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control placeholder="File Name" value={frm.fileName} required
                                        onChange={(e: any) => onFormChange("fileName", e)} />
                                    <ValResult error={errors.fileName} />
                                </Col>

                                <Form.Label column sm={2}>
                                    Custom Field
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Select aria-label="Select custom field" value={frm.customfield} onChange={(e) => onFormChange("customfield", e)} >
                                        <option key="0" value="0">Select custom field</option>
                                        <option key="1" value="1">Custom 1</option>
                                        <option key="2" value="2">Custom 2</option>
                                        <option key="3" value="3">Custom 3</option>
                                        <option key="4" value="4">Custom 4</option>
                                        <option key="5" value="5">Custom 5</option>
                                    </Form.Select>

                                    <ValResult error={errors.customfield} />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={2}>
                                    Mail Drop Date
                                </Form.Label>
                                <Col sm={4}>
                                    <DatePicker selected={mailDropDate} className="form-control" required dateFormat="MM/dd/yyyy" showYearDropdown={true} scrollableYearDropdown={true}
                                        onChange={(date: Date) => onMailDropDateChange(date)}
                                    />
                                    <ValResult error={errors.mailDropDate} />
                                </Col>

                                <Form.Label column sm={2}>
                                    Success Records
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control placeholder="Success Records" required value={frm.successRecords}
                                        onChange={(e: any) => onFormChange("successRecords", e)} />

                                    <ValResult error={errors.successRecords} />
                                </Col>
                            </Form.Group>



                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={2}>
                                    Error Records
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control placeholder="Error Records" required value={frm.errorRecords}
                                        onChange={(e: any) => onFormChange("errorRecords", e)} />
                                    <ValResult error={errors.errorRecords} />
                                </Col>
                                <Form.Label column sm={2}>
                                    Total Records
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control placeholder="Total Records" required value={frm.totalRecords}
                                        onChange={(e: any) => onFormChange("totalRecords", e)} />
                                    <ValResult error={errors.totalRecords} />
                                </Col>

                            </Form.Group>



                            <br />


                            <InputGroup className="mt-2" >
                                <FormControl

                                    placeholder="Filter"
                                    onChange={(e: any) => onSearchChanged(e.target.value)}
                                    type="search"
                                />
                            </InputGroup>




                            <div>
                                <div className="table-responsive" style={{ "fontSize": "12px" }}>
                                    <PagerTable getData={getData} columns={columns} tableData={tableData} refresh={refresh} />
                                </div>
                            </div>


                            {/* Show Delete confirm if called */}
                            {delmode !== "prompt" ? null :
                                <Confirm onResponse={onDeleteConfirm}
                                    headerText="Delete"
                                    bodyText="Are you sure you want to delete this list?"
                                    onClose={() => setDelmode("")}
                                />
                            }
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100">
                        <Button onClick={onListSaved} variant="primary" className="ms-1" > <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/disk_blue.png")`, "marginRight": "5px" }} ></i>Save</Button>
                        <Button variant="secondary" className="ms-1" onClick={close}>              <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/undo.png")`, "marginRight": "5px" }} ></i>
                            Cancel</Button>
                        {delmode !== "disabled" ? <Button variant="danger" className="float-end" onClick={() => setDelmode("prompt")}>              <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/delete.png")`, "marginRight": "5px" }} ></i>
                            Delete</Button> : null}
                    </div>
                </Modal.Footer>
            </Modal>

            {
                finderFileRecord ? <FinderFileEditor finderFile={finderFileRecord} onFinderFileSave={onFinderFileSaved} getHeaders={props.getHeaders} /> : null
            }



        </>)


}

export default ListEditor;